module.exports = __webpack_public_path__ + "static/media/upi_message_loader.0e4685bf.svg";